import "./src/assets/sass/partials/variables.scss"
import "./global.css"

const VERSION_KEY = "SITE_VERSION"

/**
 * Quando sai uma versão nova do site, limpa só os caches do navegador e recarrega UMA vez,
 * para o visitante não ficar preso em arquivos antigos.
 *
 * Não apaga cookies nem localStorage: isso derrubaria o ID do Google Analytics,
 * UTMs e consentimento a cada deploy.
 */
export const onClientEntry = () => {
  const currentVersion = process.env.GATSBY_APP_VERSION
  if (!currentVersion || currentVersion.endsWith("-dev")) return

  let storedVersion = null
  try {
    storedVersion = localStorage.getItem(VERSION_KEY)
    localStorage.setItem(VERSION_KEY, currentVersion)
  } catch (e) {
    return // storage bloqueado: não faz nada
  }

  // primeira visita: só registra a versão, sem recarregar
  if (!storedVersion || storedVersion === currentVersion) return

  console.log(`[Gatsby] Nova versão detectada (${storedVersion} -> ${currentVersion}). Atualizando cache...`)

  const reload = () => window.location.reload()

  if ("caches" in window) {
    caches
      .keys()
      .then(names => Promise.all(names.map(name => caches.delete(name))))
      .then(reload, reload)
  } else {
    reload()
  }
}
